import axios from 'axios'
import errorHandler from './error-handler'
export default {
  async checkAuth (type) {
    await axios.get(`/api/sessions/${type}`).then(r => r)
  },
  async checkProfileCompletion () {
    await axios.get(`/api/accounts/profile`).then(r => {
      return r
    }).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/sessions.js